import { Router } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { PaymentActionResponse } from 'graphql/generated';
import { isMobile } from './is-mobile.util';


const actionToRouteMap: { [s: string]: string } = {
  otp: 'otp',
  display: 'va',
  'qr-code': 'qr',
  intent: 'intent',
  javascript: 'js',
  shield: 'shield',
  'form-redirect': 'form',
  'payment-guide': 'guide',
  'redirect-qr-code': 'qr',
  
  'iframe-redirect-with-form': 'iframe-redirect',
  
  GO_TO_SHIELD_PAGE: 'payment/shield',
  GO_TO_DENOM_SELECTION_PAGE: 'denom',
  GO_TO_CHANNEL_SELECTION_PAGE: 'channel',
  GO_TO_FILL_PAYMENT_REQUIRED_FIELD_PAGE: 'checkout'
};

export function redirectTo(router: Router, txnGuid: string, action: PaymentActionResponse): void{
  if (action.status === 0 || !action.mainAction) {
    redirectTo404(
      router,
      `${ translate('info.error_occured') } [${ action.errorId }]`,
      action.message || translate('info.contact_cs')
    );
    return;
  }

  if (shouldRedirectToUnivault(action)) {
    router.navigateByUrl(`uv/${ txnGuid }`);
    return;
  }

  const route = actionToRouteMap[action.mainAction];
  if (route) {
    router.navigateByUrl(`${ route }/${ txnGuid }`);
    return;
  }

  if (action.mainAction === 'GO_TO_PCI_INITIATION_PAGE') {
    handlePciInitiation(router, txnGuid, action);
  }
}

function shouldRedirectToUnivault(action: PaymentActionResponse): boolean {
  return (
    action.mainAction === 'GO_TO_FILL_PAYMENT_REQUIRED_FIELD_PAGE' &&
    Array.isArray(action.data) &&
    action.data.some((field: any) => field.name === 'serial' || field.name === 'pin')
  );
}

function handlePciInitiation(router: Router, txnGuid: string, action: PaymentActionResponse): void {
  const type = action.data.action.actionType;
  const route = actionToRouteMap[type];

  if (type === 'redirect') {
    handleRedirectType(router, txnGuid, action.data.action.data);
    return;
  }

  if (type === 'shield') {
    router.navigateByUrl(`payment/shield/${ txnGuid }`);
    return;
  }

  if (type === 'redirect-qr-code' && isMobile()) {
    globalThis.location.href = action.data.action.data.mobile;
    return;
  }

  if (route) {
    router.navigateByUrl(`payment/${ route }/${ txnGuid }`);
  }
}

function handleRedirectType(router: Router, txnGuid: string, data: any): void {
  const targetUrl = isMobile() ? data.mobile : data.browser;
  const url = new URL(targetUrl);

  if (url.origin === globalThis.location.origin) {
    router.navigateByUrl(url.pathname + url.search);
    return;
  }

  if (isMobile()) {
    router.navigateByUrl(`payment/redirect/${ txnGuid }`);
    return;
  }
  globalThis.location.href = targetUrl;
}

export function redirectTo404(router: Router, title: string, message: string): void{
  router.navigate(
    ['404'], 
    {
      queryParams: {
        title,
        message
      }
    }
  );
}
